import { render, staticRenderFns } from "./MyPageWrapper.vue?vue&type=template&id=bfe09404&scoped=true"
import script from "./MyPageWrapper.vue?vue&type=script&lang=ts"
export * from "./MyPageWrapper.vue?vue&type=script&lang=ts"
import style0 from "./MyPageWrapper.vue?vue&type=style&index=0&id=bfe09404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe09404",
  null
  
)

export default component.exports